
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const RulesPage = lazy(() => import('../pages/rules/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CalendarPage = lazy(() => import('../pages/calendar/page'));
const TotalsPage = lazy(() => import('../pages/totals/page'));
const ScorecardPage = lazy(() => import('../pages/scorecard/page'));
const MoneyPage = lazy(() => import('../pages/money/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rules',
    element: <RulesPage />,
  },
  {
    path: '/courses',
    element: <CoursesPage />,
  },
  {
    path: '/calendar',
    element: <CalendarPage />,
  },
  {
    path: '/totals',
    element: <TotalsPage />,
  },
  {
    path: '/scorecard',
    element: <ScorecardPage />,
  },
  {
    path: '/money',
    element: <MoneyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
